import { LitElement, html, css } from "lit";

export class LoadingOverlay extends LitElement {
  static properties = {
    active: { type: Boolean, reflect: true },
    filesFound: { type: Number },
    visible: { type: Boolean, state: true },
  };

  constructor() {
    super();
    this.active = false;
    this.filesFound = 0;
    this.visible = false;
  }

  updated(changed) {
    // When active becomes true → show immediately
    if (changed.has("active")) {
      if (this.active) {
        this.visible = true;
      } else {
        // When active becomes false → wait for fade-out
        const overlay = this.shadowRoot.querySelector(".overlay");
        if (overlay) {
          const onEnd = () => {
            this.visible = false;
            overlay.removeEventListener("transitionend", onEnd);
          };
          overlay.addEventListener("transitionend", onEnd);
        }
      }
    }
  }

  static styles = css`
    :host {
      position: fixed;
      inset: 0;
      z-index: 9999;
      pointer-events: none;
    }

    .overlay {
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transform: scale(1.02);
      transition:
        opacity 220ms ease,
        transform 220ms ease;
      backdrop-filter: blur(12px) brightness(0.7);
      background: rgba(0, 0, 0, 0.35);
    }

    :host([active]) .overlay {
      opacity: 1;
      transform: scale(1);
      pointer-events: all;
    }

    .box {
      padding: 32px 40px;
      border-radius: 20px;
      background: rgba(20, 20, 25, 0.55);
      border: 1px solid rgba(255, 255, 255, 0.08);
      box-shadow: 0 8px 40px rgba(0, 0, 0, 0.4);
      text-align: center;
      min-width: 260px;
      opacity: 0;
      transform: translateY(6px);
      transition:
        opacity 240ms ease,
        transform 240ms ease;
    }

    :host([active]) .box {
      opacity: 1;
      transform: translateY(0);
    }

    .spinner {
      width: 48px;
      height: 48px;
      border: 4px solid rgba(255, 255, 255, 0.15);
      border-top-color: #4da3ff;
      border-radius: 50%;
      animation: spin 0.9s linear infinite;
      margin: 0 auto 16px;
    }

    @keyframes spin {
      to {
        transform: rotate(360deg);
      }
    }

    .label {
      font-size: 14px;
      letter-spacing: 0.5px;
      color: #e0e0e0;
      margin-bottom: 6px;
    }

    .count {
      font-size: 13px;
      color: #9bb8ff;
    }
  `;

  render() {
    if (!this.visible) return null;

    return html`
      <div class="overlay">
        <div class="box">
          <div class="spinner"></div>
          <div class="label">Scanning directory…</div>
          <div class="count">${this.filesFound} files found</div>
        </div>
      </div>
    `;
  }
}

customElements.define("loading-overlay", LoadingOverlay);
